import { render, staticRenderFns } from "./Product_2.vue?vue&type=template&id=52d47499&scoped=true"
import script from "./Product_2.vue?vue&type=script&lang=js"
export * from "./Product_2.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/PC.scss?vue&type=style&index=0&id=52d47499&prod&lang=scss&scoped=true&external"
import style1 from "./Product_2.vue?vue&type=style&index=1&id=52d47499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d47499",
  null
  
)

export default component.exports